(function($) {
	formHelper.addRule({
		form: '.form-premium-membership-cancellation',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}

				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}

				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}

				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}

				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}

	});
})(jQuery);

jQuery(function initToolsPremiumMembershipCancellationResults($) {
	$('.premium-membership-cancellation-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-premium-membership-cancellation-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});